import React, { useEffect } from 'react';
import { Button, Col, FormGroup } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import * as versionActions from '../../actions/versionActions';
import XMAuditTable from '../../components/XMAuditTable';

// Migrated from redux-form to react-hook-form. Each instance (create/edit) holds
// its own form state via useForm, so the old `form` name prop is no longer needed.
const VersionForm = ({ initialValues, isEdit, handleCancel, toggle }) => {
  const dispatch = useDispatch();
  const versionOne = useSelector((state) => state.version.one);
  const { register, handleSubmit, reset } = useForm({ defaultValues: initialValues || {} });

  // Parity with redux-form's enableReinitialize: refresh when the edited record changes.
  useEffect(() => {
    if (initialValues) reset(initialValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues && initialValues.id]);

  const onSubmit = (values) => {
    const version = values.id ? values : { ...values, release: new Date() };
    dispatch(versionActions.save(version));
    toggle();
  };

  const onCancel = () => {
    handleCancel();
    toggle();
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} className="form-horizontal">
        <FormGroup row>
          <Col md="3">
            <label htmlFor="name">Name</label>
          </Col>
          <Col md="8">
            <input {...register('name')} type="text" className="form-control" />
          </Col>
        </FormGroup>
        {isEdit ? (
          <FormGroup row>
            <Col md="3">
              <label htmlFor="release">Release</label>
            </Col>
            <Col md="8">
              <input {...register('release')} type="text" className="form-control" disabled />
            </Col>
          </FormGroup>
        ) : null}
        <FormGroup row>
          <Col md="3">
            <label htmlFor="notes">Notes</label>
          </Col>
          <Col md="8">
            <textarea {...register('notes')} className="form-control" />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md="3">
            <label htmlFor="info">Info</label>
          </Col>
          <Col md="8">
            <textarea {...register('info')} className="form-control" />
          </Col>
        </FormGroup>
        <div className="float-end">
          <Button type="button" color="secondary" className="me-2" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" color="primary">
            Save
          </Button>
        </div>
      </form>
      <XMAuditTable show={isEdit} audit={versionOne} />
    </div>
  );
};

export default VersionForm;
